import React from 'react';

import { useFilterContext } from '../../../contexts/FiltersContext';
import Filter, { BaseRangeFilter } from '../../../models/Filter';

interface RangeFilterProps {
  min: number;
  max: number;
  filter: BaseRangeFilter;
  constructor: (start, end, unit) => Filter;
}

export function useRangeFilter({ min, max, filter, constructor }: RangeFilterProps) {
  // Dependencies
  const { state } = useFilterContext();

  // States
  const [range, setRange] = React.useState<number[]>(() => {
    return [filter?.start || min, filter?.end || max];
  });
  const [unit, setUnit] = React.useState<string>();

  const getFilter: () => Filter | undefined = () => {
    if (!range) return undefined;
    if (filter) {
      filter.start = range[0];
      filter.end = range[1];
      filter.unit = unit;
      return undefined;
    }
    return constructor(range[0], range[1], unit);
  };

  const onRangeChange = (startRange: number, endRange: number, unit?: string) => {
    setRange([startRange, endRange]);
    setUnit(unit);
  };

  React.useEffect(() => {
    setRange([filter?.start || min, filter?.end || max]);
    setUnit(filter?.unit);
  }, [state, filter, min, max]);

  const onCancel = () => {
    setRange([filter?.start || min, filter?.end || max]);
    setUnit(filter?.unit);
  };

  return {
    getFilter,
    onRangeChange,
    range,
    onCancel,
    unit,
  };
}
